import { handleActions } from 'redux-actions'
import {
  FETCH_MALL_BANNER_SUCCESS
} from '../constants/mallConstant'

const initState = {
  data: []
}

export const mallBanner = handleActions({
  [FETCH_MALL_BANNER_SUCCESS]: (state, action) => {
    return {
      data: action.payload.banners
    }
  }
}, initState)
